

const Break = ( { breakLines = "0" } ) => {


    const n = parseInt(breakLines, 10) + 1

    if(!n){
        return null;
    }

    return [...Array(n)].map((e, i) => <br key={i} />);


};

export default Break;